var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page-detail-body-container" },
    [
      _c("div", { staticClass: "w-100 d-flex justify-content-end mb-3" }, [
        _vm.showBtnUpdateTable
          ? _c(
              "button",
              {
                staticClass: "form-page-detail-button",
                on: {
                  click: function($event) {
                    _vm.openModalUpdateTable(_vm.$v.workflow)
                  }
                }
              },
              [_vm._v("\n      Save\n    ")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "workflow-data-container" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("h4", [_vm._v("Standard Workflow")])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "6" } }, [
                _c("img", {
                  staticClass: "pull-right cursor-pointer",
                  attrs: {
                    src: require("@/assets/form-data/" +
                      (_vm.workflowActive === "standard" ? "on" : "off") +
                      ".png")
                  },
                  on: {
                    click: function($event) {
                      _vm.workflowActive = "standard"
                      _vm.setChangesValueView(true)
                    }
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.workflowActive === "standard",
                  expression: "workflowActive === 'standard'"
                }
              ]
            },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "m__b--15",
                  class: { "error-input": _vm.$v.workflow.defaultRule.$error },
                  staticStyle: { width: "99%" }
                },
                [
                  _c("label", [_vm._v("Default Rule ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      "error-required": _vm.$v.workflow.defaultRule.$error,
                      "is-async": true,
                      "cache-options": false,
                      "load-options": _vm.loadOptionsRule,
                      placeholder: "Select Default Rule",
                      "value-format": "object",
                      label: "name"
                    },
                    on: { input: _vm.changeRule },
                    model: {
                      value: _vm.$v.workflow.defaultRule.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.workflow.defaultRule, "$model", $$v)
                      },
                      expression: "$v.workflow.defaultRule.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "m__b--5" }, [_vm._v("Exception Rule")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      attrs: { id: "privilegeForm" }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("j-input", {
                    staticStyle: { width: "250px" },
                    attrs: { "error-required": false, placeholder: "Search" },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-rule" },
                _vm._l(_vm.dataRuleFiltered, function(value, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "rectangle-rule" },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "1" } }, [
                            value.user.photo_url
                              ? _c("img", {
                                  staticClass: "card-assignee-photo-modal",
                                  attrs: {
                                    title: value.user.first_name,
                                    src: value.user.photo_url
                                  }
                                })
                              : _c(
                                  "span",
                                  {
                                    staticClass: "card-assignee-initial-modal",
                                    attrs: { title: value.user.first_name }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getUserInitial(value.user)) +
                                        "\n              "
                                    )
                                  ]
                                )
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "4" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(value.user.first_name) +
                                " " +
                                _vm._s(value.user.last_name) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "label-position" }, [
                              _vm._v(_vm._s(value.organigram_name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "5" } }, [
                            value.type === "rule"
                              ? _c("div", [
                                  _vm._v("\n                RULE "),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(value.rule.name) +
                                      "\n              "
                                  )
                                ])
                              : _c("div", [_vm._v("AUTO APPROVE")])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "2" } }, [
                            _c(
                              "span",
                              {
                                staticClass: "cursor-pointer pull-right",
                                on: {
                                  click: function($event) {
                                    _vm.deleteRule(value, index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash fa-2x" })]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "workflow-data-container" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("h4", [_vm._v("Advance Workflow")])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "6" } }, [
                _c("img", {
                  staticClass: "pull-right cursor-pointer",
                  attrs: {
                    src: require("@/assets/form-data/" +
                      (_vm.workflowActive === "dynamic" ? "on" : "off") +
                      ".png")
                  },
                  on: {
                    click: function($event) {
                      _vm.workflowActive = "dynamic"
                      _vm.setChangesValueView(true)
                    }
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.workflowActive === "dynamic",
                  expression: "workflowActive === 'dynamic'"
                }
              ]
            },
            [
              _vm._v("\n      Approver Selection\n      "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "container-option-flow manual-flow m__r--10",
                    class:
                      _vm.approvalSelection === "manual" ? "option-active" : "",
                    on: {
                      click: function($event) {
                        _vm.approvalSelection = "manual"
                        _vm.setChangesValueView(true)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-option" }, [
                      _vm._v("Manual")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-option-flow",
                    class:
                      _vm.approvalSelection === "function"
                        ? "option-active"
                        : "",
                    on: {
                      click: function($event) {
                        _vm.approvalSelection = "function"
                        _vm.setChangesValueView(true)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-option" }, [
                      _vm._v("Function")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-option-small" }, [
                      _vm._v("Visual Programming")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.approvalSelection === "manual"
                ? _c("div", { staticClass: "m__t--15" }, [_vm._v("Type")])
                : _vm._e(),
              _vm._v(" "),
              _vm.approvalSelection === "manual"
                ? _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "container-option-flow manual-flow manual-by-flow m__r--10",
                        class:
                          _vm.manualSelection === "by_organigram"
                            ? "option-active"
                            : "",
                        on: {
                          click: function($event) {
                            _vm.manualSelection = "by_organigram"
                            _vm.setChangesValueView(true)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "text-option" }, [
                          _vm._v("by Organigram")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.approvalSelection === "function"
                ? _c(
                    "b-form-group",
                    {
                      staticClass: "m__t--15",
                      class: {
                        "error-input": _vm.$v.workflow.function_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Function Name ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required":
                            _vm.$v.workflow.function_name.$error,
                          options: _vm.listFunction,
                          placeholder: "Select Function Name",
                          label: "name"
                        },
                        on: { input: _vm.changeFunction },
                        model: {
                          value: _vm.$v.workflow.function_name.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.workflow.function_name,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.workflow.function_name.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "popoverAddBoardAssignee",
          attrs: {
            show: _vm.popoverPrivilegeForm,
            target: "privilegeForm",
            triggers: "click",
            placement: "left",
            container: "privilege-setting-container"
          },
          on: {
            "update:show": function($event) {
              _vm.popoverPrivilegeForm = $event
            }
          }
        },
        [
          _c("h3", [_vm._v("Add Rule Workflow")]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.dataPrivilege.position.$error } },
            [
              _c("label", { attrs: { for: "position" } }, [_vm._v("Position")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  id: "position",
                  "is-async": true,
                  "cache-options": false,
                  "load-options": _vm.loadOptionsPosition,
                  placeholder: "Select Position",
                  "value-format": "object",
                  label: "name"
                },
                model: {
                  value: _vm.dataPrivilege.position,
                  callback: function($$v) {
                    _vm.$set(_vm.dataPrivilege, "position", $$v)
                  },
                  expression: "dataPrivilege.position"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("label", [_vm._v("Without Approver")]),
              _vm._v(" "),
              _c("j-toggle", {
                model: {
                  value: _vm.dataPrivilege.withoutApprover,
                  callback: function($$v) {
                    _vm.$set(_vm.dataPrivilege, "withoutApprover", $$v)
                  },
                  expression: "dataPrivilege.withoutApprover"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.dataPrivilege.withoutApprover
            ? _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.dataPrivilege.rule.$error } },
                [
                  _c("label", { attrs: { for: "rule" } }, [_vm._v("Rule")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      id: "rule",
                      "is-async": true,
                      "cache-options": false,
                      "load-options": _vm.loadOptionsRule,
                      placeholder: "Select Rule",
                      "value-format": "object",
                      label: "name"
                    },
                    model: {
                      value: _vm.dataPrivilege.rule,
                      callback: function($$v) {
                        _vm.$set(_vm.dataPrivilege, "rule", $$v)
                      },
                      expression: "dataPrivilege.rule"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  _vm.popoverPrivilegeForm = false
                }
              }
            },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btn blue", on: { click: _vm.addPrivilegeForm } },
            [_vm._v("\n      Add\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowModalUpdateTable
        ? _c("j-modal-update-table", {
            attrs: {
              id: "modalUpdateTableId",
              "table-name": _vm.form_data.name
            },
            on: {
              submit: _vm.handleSubmitForm,
              close: _vm.closeModalUpdateTable
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "container-option-flow manual-flow manual-by-flow",
        staticStyle: { cursor: "no-drop" }
      },
      [
        _c("span", { staticClass: "text-option" }, [_vm._v("by Flow")]),
        _c("br")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68035b02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68035b02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormWorkflow.vue
// module id = null
// module chunks = 